// extracted by mini-css-extract-plugin
export const guideContainer = "GuidelinesBlock-module--guide-container--1pFJ4";